export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";

export const INSERT_USER = "INSERT_USER";
export const INSERT_USER_SUCCESS = "INSERT_USER_SUCCESS";
export const INSERT_USER_FAIL = "INSERT_USER_FAIL";

export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";

export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";

export const GET_USER_BALANCE = "GET_USER_BALANCE";
export const GET_USER_BALANCE_SUCCESS = "GET_USER_BALANCE_SUCCESS";
export const GET_USER_BALANCE_FAIL = "GET_USER_BALANCE_FAIL";

export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_FAIL = "GET_USER_INFO_FAIL";

export const GET_USER_FILES = "GET_USER_FILES";
export const GET_USER_FILES_SUCCESS = "GET_USER_FILES_SUCCESS";
export const GET_USER_FILES_FAIL = "GET_USER_FILES_FAIL";

export const ADD_USER_FILE = "ADD_USER_FILE";
export const ADD_USER_FILE_SUCCESS = "ADD_USER_FILE_SUCCESS";
export const ADD_USER_FILE_FAIL = "ADD_USER_FILE_FAIL";

export const DELETE_USER_FILE = "DELETE_USER_FILE";
export const DELETE_USER_FILE_SUCCESS = "DELETE_USER_FILE_SUCCESS";
export const DELETE_USER_FILE_FAIL = "DELETE_USER_FILE_FAIL";


export const RESET_USER_FLAG = "RESET_USER_FLAG";